import MainPageAssinatura from '@/screens/assinatura/MainPage'
import HomeAssinatura from '@/screens/assinatura/Home'
import CadastroDocumento from '@/screens/assinatura/CadastroDocumento'
import ListagemDocumentosAssinados from '@/screens/assinatura/ListagemDocumentosAssinados'
import VisualizarDocumento from '@/screens/assinatura/VisualizarDocumento'
import AssinarDocumento from '@/screens/assinatura/AssinaturaDocumento'
import CadastroCertificado from '@/screens/assinatura/CadastroCertificado'

import PERFIL from '@/constants/perfil'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const perfisAssinatura = [PERFIL.ASSINATURA.ASSINADOR.codigo]

const assinatura = [
  {
    path: '/assinatura',
    name: PERFIL.ASSINATURA.CODIGO_MODULO,
    meta: {
      codigoModulo: PERFIL.ASSINATURA.CODIGO_MODULO,
      perfis: perfisAssinatura

    },
    component: MainPageAssinatura,
    children: [
      {
        path: 'home',
        name: 'assinatura/home',
        component: HomeAssinatura,
        meta: {
          ...setRouteGroup('ASSINATURA_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'cadastrarDocumento',
        name: 'assinatura/cadastrarDocumento',
        component: CadastroDocumento,
        meta: {
          ...setRouteGroup('ASSINATURA_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'cadastrarCertificado',
        name: 'assinatura/cadastrarCertificado',
        component: CadastroCertificado,
        meta: {
          ...setRouteGroup('ASSINATURA_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'documentosAssinados',
        name: 'assinatura/documentosAssinados',
        component: ListagemDocumentosAssinados,
        meta: {
          ...setRouteGroup('ASSINATURA_DOCUMENTOS_ASSINADOS')
        }
      },
      {
        path: 'visualizarDocumento',
        name: 'assinatura/visualizarDocumento',
        component: VisualizarDocumento,
        meta: {
          ...setRouteGroup('ASSINATURA_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'visualizarDocumentoAssinado',
        name: 'assinatura/visualizarDocumentoAssinado',
        component: VisualizarDocumento,
        meta: {
          ...setRouteGroup('ASSINATURA_DOCUMENTOS_ASSINADOS')
        }
      },
      {
        path: 'assinarDocumento',
        name: 'assinatura/assinarDocumeto',
        component: AssinarDocumento,
        meta: {
          ...setRouteGroup('ASSINATURA_CAIXA_DE_ENTRADA')
        }
      }
    ]
  }
]

export default assinatura



// WEBPACK FOOTER //
// ./src/router/assinatura.js